import * as React from "react";
const SvgFiRrRegionPinAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-region-pin-alt_svg__a)">
      <path
        fill="#062147"
        d="M23 12a1 1 0 0 0-1 1v3h-6.086L10 10.086V2h1a1 1 0 1 0 0-2H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5v-6a1 1 0 0 0-1-1M5 2h3v7.9l-6 3.199V5c0-1.654 1.346-3 3-3M2 19v-3.633l6.817-3.636 5.362 5.362-3.679 4.906H5c-1.654 0-3-1.345-3-2.999m17 3h-6l3-4h6v1c0 1.654-1.346 3-3 3m-2.549-10.811a2.91 2.91 0 0 0 2.049.828 2.92 2.92 0 0 0 2.049-.828l1.84-1.801A5.46 5.46 0 0 0 24 5.499a5.46 5.46 0 0 0-1.611-3.889A5.46 5.46 0 0 0 18.5-.001a5.46 5.46 0 0 0-3.889 1.611A5.46 5.46 0 0 0 13 5.499c0 1.47.572 2.851 1.619 3.896zm-.426-8.164A3.48 3.48 0 0 1 18.5 2c.936 0 1.813.364 2.475 1.025A3.47 3.47 0 0 1 22 5.5a3.47 3.47 0 0 1-1.018 2.467L19.15 9.76a.935.935 0 0 1-1.301 0l-1.824-1.785A3.48 3.48 0 0 1 15 5.5c0-.935.364-1.813 1.025-2.475m.974 2.469A1.5 1.5 0 1 1 20 5.495 1.5 1.5 0 0 1 17 5.494"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-region-pin-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRegionPinAlt;
